module.exports = __webpack_public_path__ + "img/team-rob.627cecc7.jpg";